import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <Svg viewBox="0 0 60 60" {...props}>
      <path d="M46.47 20.07h-5.31a2.15 2.15 0 01-1.61-.72l-2.16-2.42a1.69 1.69 0 00-2.53 0L33 19a3.21 3.21 0 01-2.39 1.07h-29A30.26 30.26 0 000 27.48h27.42a1.78 1.78 0 001.28-.54l2.56-2.66a1.67 1.67 0 011.22-.52h.1a1.7 1.7 0 011.27.57L36 26.75a2.17 2.17 0 001.61.73H60a30.26 30.26 0 00-1.58-7.41h-12zM16.6 43.05a1.78 1.78 0 001.27-.54l2.56-2.66a1.7 1.7 0 011.22-.52h.1a1.7 1.7 0 011.25.57l2.15 2.42a2.14 2.14 0 001.62.73h30.35a29.73 29.73 0 002.47-7.48H30.47a2.17 2.17 0 01-1.62-.72l-2.15-2.43a1.69 1.69 0 00-2.53 0l-1.85 2.08a3.18 3.18 0 01-2.38 1.07H.41a29.73 29.73 0 002.47 7.48zM38.12 12a1.74 1.74 0 001.27-.54L42 8.78a1.69 1.69 0 011.22-.51h.1a1.69 1.69 0 011.27.56l2.15 2.43a2.17 2.17 0 001.62.72h5.77A30.19 30.19 0 005.92 12zM26.53 50.46h-7.89a2.17 2.17 0 01-1.64-.72l-2.15-2.43a1.71 1.71 0 00-2.53 0l-1.85 2.08a3.18 3.18 0 01-2.38 1.07H8a30.16 30.16 0 0044 0z" />
    </Svg>
  );
};

export default Icon;
